﻿document.addEventListener('DOMContentLoaded', () => {
    const $navbar = document.getElementById('navbar');
    const $body = document.getElementsByTagName('body')[0];
    var prevScroll = 0;
    if (document.getElementById('navbar')) {
        document.addEventListener('scroll', () => {
            nextScroll = window.scrollY;
            if  (nextScroll === 0) {
                $navbar.classList.add('is-top');
                $body.classList.remove("scrollDown");
                $body.classList.remove("scrollUp");
            }
            else {
                $navbar.classList.remove('is-top');
            }
            if (prevScroll - nextScroll < 0) {
                $body.classList.remove("scrollUp");
                if (nextScroll !== 0) $body.classList.add("scrollDown");
            } else {
                $body.classList.remove("scrollDown");
                if (nextScroll !== 0) $body.classList.add("scrollUp");
            }
            prevScroll = nextScroll;
        });
    }
});